import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
    FaRegEye,
    FaBolt,
    FaBan
} from "react-icons/fa";
import { BACKEND } from "../../config/configEnvs";
import { FaSpinner } from "react-icons/fa";
import { FaPowerOff } from "react-icons/fa";
import { toast } from "react-toastify";
import { FaBarcode } from "react-icons/fa";
import MotionNumber from "motion-number";

const ItemRowSeguimientoServiciosCliente = ({client, service}) => {

    const user = useSelector((state) => state.auth.user); // Usuario

    const serviceId = service.id

    const [tasks, setTasks] = useState([])
    const [objectives, setObjectives] = useState([])
    const [phases, setPhases] = useState([])

    const [formulariosList, setFormulariosList] = useState([])

    const fetchFormulariosRespuestas = async () => { // Se traen los formularios
        if (user) {
          try {
            const response = await axios.get(
              `${BACKEND}/api/formularioServicioRespuestas?where[servicioCotizacion][equals]=${serviceId}`
            );
            setFormulariosList(response.data.docs);
          } catch (error) {
            toast.error("No se pudieron traer las encuentas: " + error);
          }
        }
    };

    const fetchProcesses = async () => { // Se traen los procesos del servicio
        try {
          const tasks = await axios.get(`${BACKEND}/api/tareasProyectos?where[objective.phase.service][equals]=${serviceId}&limit=0&depth=3`)
    
          const objectives = await axios.get(`${BACKEND}/api/objetivosProyectos?where[phase.service][equals]=${serviceId}&limit=0`)
    
          const phases = await axios.get(`${BACKEND}/api/fasesProyectos?where[service][equals]=${serviceId}&limit=0`)
    
          setTasks(tasks.data.docs)
          setObjectives(objectives.data.docs)
          setPhases(phases.data.docs)
    
        } catch (error) {
          toast.error("Error obteniendo las fases del proyecto: " + error)
        }
    }

    const extractNumberFromName = (str) => { // Función para extraer el número después de "TWA", "Objetivo" o "Fase"
        const match = str.match(/(?:TWA|Objetivo|Fase)\s*(\d+)/);
        return match ? parseInt(match[1], 10) : 0;
    };

    const sortPhases = (phases) => { // Ordenar fases de menor a mayor según el número
        return phases.sort((a, b) => extractNumberFromName(a.phase.name) - extractNumberFromName(b.phase.name));
    };

    const sortObjectives = (objectives) => { // Ordenar objetivos de menor a mayor según el número
        return objectives.sort((a, b) => extractNumberFromName(a.objective.name) - extractNumberFromName(b.objective.name));
    };

    const sortTasks = (tasks) => { // Ordenar tareas de menor a mayor según el número
        return tasks.sort((a, b) => extractNumberFromName(a.task.name) - extractNumberFromName(b.task.name));
    };

    // Agrupar las tareas, objetivos y fases
    const groupPhasesObjectivesTasks = (phases, objectives, tasks) => {
        const sortedPhases = sortPhases(phases);
        const sortedObjectives = sortObjectives(objectives);
        const sortedTasks = sortTasks(tasks);

        return sortedPhases.map(phase => ({
            objetivos: sortedObjectives
            .filter(obj => obj.phase.id === phase.id) // Filtrar los objetivos que pertenecen a esta fase
            .map(obj => ({
                tareas: sortedTasks
                .filter(task => task.objective.id === obj.id) // Filtrar las tareas que pertenecen a este objetivo
                .map(task => ({
                    status: task.status,
                })),
            })),
        }));
    };

    const groupedData = groupPhasesObjectivesTasks(phases, objectives, tasks)

    const countCompleted = (phases) => { 
        let completedTasks = 0;
        let completedPhases = 0;
        let completedObjectives = 0;
    
        phases.forEach((fase) => {
            let completedPhase = true; // Asumimos que la fase está completa hasta que se demuestre lo contrario
    
            fase.objetivos.forEach((objetivo) => {
                // Contar cuántas tareas están finalizadas
                const tasksCompleted = objetivo.tareas.filter(tarea => tarea.status === 'Finalizado' || tarea.status === 'Con retraso').length;
                
                completedTasks += tasksCompleted; // Sumar las tareas completadas
                
                // Comprobar si todas las tareas del objetivo están finalizadas
                const objectiveCompleted = objetivo.tareas.every(tarea => tarea.status === 'Finalizado' || tarea.status === 'Con retraso');
                
                if (objectiveCompleted) {
                    completedObjectives++; // Contamos el objetivo como completado
                } else {
                    completedPhase = false; // Si un objetivo no está completado, la fase no puede estar completada
                }
            });
    
            if (completedPhase) {
                completedPhases++; // Si todos los objetivos de la fase están completados, contamos la fase
            }
        });
    
        return {
            completedTasks,
            completedPhases,
            completedObjectives
        };
    };    

    const count = countCompleted(groupedData)

    // Calcular porcentaje y color

    const calculatePercentage = (value1, value2) => { // Calcular el porcentaje entre 2 valores
        if (value2 === 0) return 0; 
        return (value1 / value2) * 100;
    };

    const percentajeCompleted = calculatePercentage(count.tasksCompleted, tasks.length) // Porcentaje de tareas completadas

    const getTextColorForPercentage = (percentage) => {// Obtener el text color
        if (percentage === 100) return 'text-green-500'; // Verde oscuro
        if (percentage >= 87.5) return 'text-green-400'; // Verde más claro
        if (percentage >= 75) return 'text-green-300'; // Verde aún más claro
        if (percentage >= 62.5) return 'text-yellow-400'; // Amarillo
        if (percentage >= 50) return 'text-yellow-300'; // Amarillo más claro
        if (percentage >= 37.5) return 'text-orange-400'; // Naranja
        if (percentage >= 25) return 'text-orange-300'; // Naranja más claro
        if (percentage >= 12.5) return 'text-red-600'; // Rojo
        return 'text-red-800'; // Rojo más claro
    };

    const textColorClass = getTextColorForPercentage(count.completedTasks / tasks.length * 100); // Clase de color de texto

    const copyToClipBoard = (id) => {
        navigator.clipboard.writeText(id).then(() => {
            toast.success("ID copiado al portapapeles")
        }).catch((err) => {
            toast.error("Error al copiar el ID: " + err);
        })
    }

    useEffect(() => {
        fetchProcesses()
        fetchFormulariosRespuestas()
    }, [])

    const getStatusClass = (estado) => {
        switch (estado) {
            case "Terminado con exito":
                return "text-green-500";
            case "Por comenzar":
                return "text-yellow-300";
            case "En proceso":
                return "text-blue-500";
            case "Abandonado":
                return "text-black";
            case "Congelado":
                return "text-gray-500";
            default:
                return "text-sky-300";
        }
    };
    

    return (
            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 transition-all duration-100">

                <td scope="row" className="px-6 py-3">
                    <div className="flex justify-start items-center gap-2">
                        <Link to={`/home/seguimiento/${client}/${service.servicio.name}/${service.id}`}>
                            <div className="p-2 text-blue-500 hover:bg-blue-600 hover:bg-opacity-25 rounded-md bg-blue-700 bg-opacity-10">
                                <FaRegEye className=" " />
                            </div>
                        </Link>
                    </div>
                </td>

                <td scope="col" className="px-6 py-3 text-center">
                    <button
                        className="text-yellow-500 hover:text-yellow-700"
                        onClick={() => copyToClipBoard(service.id)}
                    >
                        <div className="p-2 text-yellow-500 hover:bg-yellow-600 hover:bg-opacity-25 rounded-md bg-yellow-700 bg-opacity-10">
                            <FaBarcode className=" " />
                        </div>
                    </button>
                </td>

                <td scope="col" className="px-6 py-3 text-center">
                    <span className={getStatusClass(service.estado)}>
                        {service.estado}
                    </span>
                </td>

                <td scope="col" className="px-6 py-3 text-center">               
                    <span>
                        {
                            <>
                                <MotionNumber
                                    value={count.completedTasks}
                                    format={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
                                    locales="en-US"
                                />
                                {" / "}
                                <MotionNumber
                                    value={tasks.length}
                                    format={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
                                    locales="en-US"
                                />
                            </>
                        }
                    </span>
                </td>

                <td scope="col" className="px-6 py-3 text-center">               
                    <span>
                        {
                            <>
                                <MotionNumber
                                    value={count.completedObjectives}
                                    format={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
                                    locales="en-US"
                                />
                                {" / "}
                                <MotionNumber
                                    value={objectives.length}
                                    format={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
                                    locales="en-US"
                                />
                            </>
                        }
                    </span>
                </td>

                <td scope="col" className="px-6 py-3 text-center">               
                    <span>
                        {
                            <>
                                <MotionNumber
                                    value={count.completedPhases}
                                    format={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
                                    locales="en-US"
                                />
                                {" / "}
                                <MotionNumber
                                    value={phases.length}
                                    format={{ minimumFractionDigits: 0, maximumFractionDigits: 0 }}
                                    locales="en-US"
                                />
                            </>
                        }
                    </span>
                </td>

                <td scope="col" className="px-6 py-3 text-center">
                    <span className={textColorClass}>
                        {isNaN(count.completedTasks / tasks.length * 100) ? (
                            <span>Proceso no iniciado</span>
                        ) : (
                            <>
                                <MotionNumber
                                    value={(count.completedTasks / tasks.length) * 100}
                                    format={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
                                    locales="en-US"
                                />
                                {" %"}
                            </>
                        )}
                    </span>
                </td>


                <td scope="col" className="px-6 py-3 text-center">
                    {new Date(service.fechaInicio).toLocaleDateString()}
                </td> 

                <td scope="col" className="px-6 py-3 text-center">
                    {new Date(service.fechaFin).toLocaleDateString()}
                </td> 

                <td scope="col" className="px-6 py-3 text-center"> 
                    {formulariosList.length > 0 ? "Si" : "No" }
                </td>

                <td scope="col" className="px-6 py-3 text-center">
                    <button
                        className="text-yellow-500 hover:text-yellow-700"
                        onClick={() => copyToClipBoard(service.cotizacion.id)}
                    >
                        <div className="p-2 text-yellow-500 hover:bg-yellow-600 hover:bg-opacity-25 rounded-md bg-yellow-700 bg-opacity-10">
                            <FaBarcode className=" " />
                        </div>
                    </button>
                </td>
                
            </tr>   
    )
}

export default ItemRowSeguimientoServiciosCliente